import { MAX_POLLING_RETRIES, POLLING_DELAY } from "../constants/polling";
import { verificationCustomerStatus } from "../constants/verification-status";
import noticeError from "./notice-error";
import sdkProvider from "./sdk-provider";

const delay = async (t) => new Promise((resolve) => setTimeout(resolve, t));

const isCustomerSuccess = (response) => {
  return (
    response.data.status === verificationCustomerStatus.ACTIVE ||
    response.data.status === verificationCustomerStatus.PENDING_VERIFICATION
  );
};

export async function fetchStudentStatus(requestHelper) {
  const identity = await sdkProvider("identity");
  const authHeader = await identity.getAuthHeader();
  const customerId = await identity.customer.customerId();

  let retries = 1;
  const maxRetries = MAX_POLLING_RETRIES;

  try {
    while (retries <= maxRetries) {
      const response = await requestHelper.get({
        url: `/api/marketing/student/v1/customers/${customerId}`,
        headers: {
          Authorization: authHeader,
        },
      });

      if (isCustomerSuccess(response) || retries === maxRetries) {
        return response.data;
      }
      retries = retries + 1;
      await delay(POLLING_DELAY);
    }
  } catch (error) {
    noticeError(error);
  }
}
